import { useContext } from "react";
import { AuthContext, AuthProvider } from "../context/AuthContext";

// Re-exportamos el contexto y el provider
export { AuthContext, AuthProvider };
export default AuthContext;

// Creamos el hook useAuth aquí mismo
export const useAuth = () => {
  const context = useContext(AuthContext);
  if (context === undefined) {
    throw new Error("useAuth debe usarse dentro de un AuthProvider");
  }
  return context;
};
